import { createSlice } from '@reduxjs/toolkit';
import { ServiceState } from './state';
import reducers from './reducers';

const initialState: ServiceState = {
  privateSpace: [],
  membershipService: [],
};

const service = createSlice({
  name: 'service',
  initialState,
  reducers,
});

export const serviceActions = { ...service.actions };
export default service;
